import z from "zod/v4";

const decoder = new TextDecoder("utf-8", { fatal: true });
const encoder = new TextEncoder(); // TextEncoder is always UTF-8

/**
 * Codec that wraps a string-encoded schema and transforms to/from UTF-8 bytes.
 *
 * @example
 * const MessageBytes = Utf8(Json(Message({...})));
 * const bytes = MessageBytes.encode(message); // Uint8Array
 * const message = MessageBytes.decode(bytes); // decoded message
 */
export const Utf8 = <T>(schema: z.ZodType<T, string>) =>
  z.codec(z.custom<Uint8Array>(), schema, {
    decode: (bytes, ctx) => {
      try {
        return decoder.decode(bytes);
      } catch (err: unknown) {
        ctx.issues.push({
          code: "invalid_format",
          format: "utf-8",
          input: undefined,
          message: err instanceof Error ? err.message : undefined,
        });
        return z.NEVER;
      }
    },
    encode: (value) => encoder.encode(value),
  });
